//#region src/bite_log_type.ts
var BiteLogType = /* @__PURE__ */ function(BiteLogType) {
	BiteLogType[BiteLogType["Simple"] = 0] = "Simple";
	BiteLogType[BiteLogType["Printer"] = 1] = "Printer";
	BiteLogType[BiteLogType["FatalError"] = 4] = "FatalError";
	BiteLogType[BiteLogType["Device"] = 5] = "Device";
	BiteLogType[BiteLogType["Maitred"] = 8] = "Maitred";
	BiteLogType[BiteLogType["Pusher"] = 9] = "Pusher";
	BiteLogType[BiteLogType["Square"] = 10] = "Square";
	BiteLogType[BiteLogType["CardConnect"] = 11] = "CardConnect";
	BiteLogType[BiteLogType["Worldpay"] = 12] = "Worldpay";
	BiteLogType[BiteLogType["Kiosk"] = 13] = "Kiosk";
	BiteLogType[BiteLogType["Loyalty"] = 14] = "Loyalty";
	BiteLogType[BiteLogType["Heartland"] = 15] = "Heartland";
	BiteLogType[BiteLogType["Stripe"] = 16] = "Stripe";
	BiteLogType[BiteLogType["FreedomPay"] = 17] = "FreedomPay";
	BiteLogType[BiteLogType["Elavon"] = 19] = "Elavon";
	BiteLogType[BiteLogType["VerifonePointCloud"] = 20] = "VerifonePointCloud";
	BiteLogType[BiteLogType["Eigen"] = 21] = "Eigen";
	BiteLogType[BiteLogType["Adyen"] = 22] = "Adyen";
	BiteLogType[BiteLogType["OloPayKiosk"] = 23] = "OloPayKiosk";
	BiteLogType[BiteLogType["VerifonePointSca"] = 24] = "VerifonePointSca";
	BiteLogType[BiteLogType["LrsTableTracker"] = 25] = "LrsTableTracker";
	BiteLogType[BiteLogType["Flash"] = 26] = "Flash";
	BiteLogType[BiteLogType["ParPay"] = 27] = "ParPay";
	BiteLogType[BiteLogType["Chase"] = 28] = "Chase";
	BiteLogType[BiteLogType["Moneris"] = 29] = "Moneris";
	BiteLogType[BiteLogType["JTechTableTracker"] = 30] = "JTechTableTracker";
	BiteLogType[BiteLogType["Glory"] = 31] = "Glory";
	BiteLogType[BiteLogType["VerifoneCommander"] = 32] = "VerifoneCommander";
	BiteLogType[BiteLogType["ExpoPrinter"] = 33] = "ExpoPrinter";
	BiteLogType[BiteLogType["TransactCampusCard"] = 34] = "TransactCampusCard";
	return BiteLogType;
}(BiteLogType || {});
//#endregion
export { BiteLogType };

//# sourceMappingURL=bite_log_type.js.map